import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { InventoryProducedStatusResponse } from '../apis/inventory.api'
import { ShipShippedStatusResponse } from '../apis/ship.api'
import CountCard, { CountData } from '../components/CountCard'
import PageHeading from '../components/PageHeading'

interface InventoryMeasuresData {
  name: string
  icon: string
  heading: string
  counts: CountData[]
}

interface InventoryMeasuresProps {
  producedStatus: InventoryProducedStatusResponse | null
  warehouseCapacity: number | null
  shippedStatus: ShipShippedStatusResponse | null
}

export default class InventoryMeasures
  extends Component<InventoryMeasuresProps> {
  statusCounts (
    status: InventoryProducedStatusResponse | ShipShippedStatusResponse | null
  ) {
    if (!status) return []
    const { daily, weekly, monthly } = status
    return [
      {
        primary: `${daily.quantity} ${i18n("units")}`,
        secondary: `${daily.average} ${i18n("daily")}`,
        tooltip: `${i18n("Average calculated based on last 14 days")}`
      },
      {
        primary: `${weekly.quantity} ${i18n("units")}`,
        secondary: `${weekly.average} ${i18n("weekly")}`,
        tooltip: `${i18n("Average calculated based on last 6 weeks")}`
      },
      {
        primary: `${monthly.quantity} ${i18n("units")}`,
        secondary: `${monthly.average} ${i18n("monthly")}`,
        tooltip: `${i18n("Average calculated based on last 3 months")}`
      }
    ]
  }

  get measures (): InventoryMeasuresData[] {
    const { producedStatus, shippedStatus } = this.props
    return [
      {
        name: 'producedUnits',
        icon: 'book-read',
        heading: `${i18n("Units Produced")}`,
        counts: this.statusCounts(producedStatus)
      },
      {
        name: 'warehouseCapacity',
        icon: 'building-2',
        heading: `${i18n("Warehouse Capacity")}`,
        counts: [
          {
            primary: `${this.props.warehouseCapacity || 0}%`,
            secondary: `${i18n("occupied")}`
          }
        ]
      },
      {
        name: 'shippedUnits',
        icon: 'truck',
        heading: `${i18n("Units Shipped")}`,
        counts: this.statusCounts(shippedStatus)
      }
    ]
  }

  inventoryMeasure (measure: InventoryMeasuresData) {
    return (
      <CountCard
        type="white"
        icon={measure.icon}
        heading={measure.heading}
        counts={measure.counts}
        key={measure.name} />
    )
  }

  get inventoryMeasures () {
    return this.measures.map(measure => this.inventoryMeasure(measure))
  }

  render () {
    return (
      <div className="block">
        <PageHeading
          text={i18n("Inventory Measures")}
          doc='dashboard' />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {this.inventoryMeasures}
        </div>
      </div>
    )
  }
}
